import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Stack, ThemeProvider, Typography } from "@mui/material";
import { createTheme } from '@mui/material/styles'; 
import NewsFeedGrid from '../../components/grids/NewsFeedGrid/NewsFeedGrid';
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; 
import { useGetCartQuery, useGetUserInfoQuery } from "../../services/grace";
import CartItemDialog from "../../components/dialogs/CartItemDialog/CartItemDialog";
import AppDrawerHome from "../../components/app/AppDrawer/AppDrawerHome";
import StyledButton from "../../components/app/StyledButton/StyledButton";
import { theme } from '../../themes/theme'; // Import the theme

const homeTheme = createTheme({ 
    ...theme, // Spread parent theme
    components: {
      ...theme.components,
      MuiTypography: {
        styleOverrides: {
          root: {
            fontWeight: 'bold',
          },
        },
      },
    },
});

export default function Home(): JSX.Element {
     
    // Get today's date
    const today = new Date();
    
    // Format the date
    const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' };
    const formattedDate = today.toLocaleDateString('en-GB', options);
    const {
        data: userData,
        refetch: refetchUserData,
    } = useGetUserInfoQuery();
 
    return (
        <Box sx={{padding: '30px'}}> 
            <Box>
                <ThemeProvider theme={homeTheme}>
                    <AppDrawerHome />
                </ThemeProvider>
            </Box>
            <Box sx={{paddingTop: '100px'}}>
                <Typography variant="h5" sx={{fontWeight: 'bold', marginBottom: '20px'}} >
                    Latest News & Advice
                </Typography>
                <NewsFeedGrid />
            </Box>
        </Box>
    );
}
